<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.status === 'recorded'" size="small" type="info">Rögzítve</el-tag>
      <el-tag v-if="scope.row.status === 'cancelled'" size="small" type="danger">Lemondva</el-tag>
      <el-tag v-if="scope.row.status === 'done'" size="small" type="success">Bevételezett</el-tag>
      <el-tag v-if="scope.row.status === 'partly-done'" size="small" type="warning">Részben bevételezett</el-tag>
      <el-tag v-if="scope.row.status === 'sent'" size="small" type="primary">Elküldve</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'status',
};
</script>
